import type { IconName } from '@hotjar/hotsauce';
import { IconButton, DropdownMenu } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const viewModeOptions = ['list', 'card'] as const;

export type ViewMode = (typeof viewModeOptions)[number];

export type ViewModeProps = {
  onViewModeSelected: (viewMode: ViewMode) => void;
  currentMode: ViewMode;
};

const viewModesDefinitions: Record<ViewMode, { label: string; icon: IconName }> = {
  list: { icon: 'table', label: 'table-view' },
  card: { icon: 'grid_1', label: 'card-view' },
};

export const ViewMode = ({ onViewModeSelected, currentMode }: ViewModeProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'incoming-feedback.view-mode' });

  return (
    <span aria-label={t('current-view-mode', { mode: t(viewModesDefinitions[currentMode].label) })}>
      {currentMode && (
        <DropdownMenu
          trigger={
            <IconButton
              size="s"
              kind="ghost"
              icon={viewModesDefinitions[currentMode].icon}
              tooltipText={t('tooltip')}
            />
          }
        >
          {viewModeOptions.map((viewMode) => {
            return (
              <DropdownMenu.Item
                key={viewMode}
                onClick={() => onViewModeSelected(viewMode)}
                icon={viewModesDefinitions[viewMode].icon}
                isSelected={viewMode === currentMode}
              >
                {t(viewModesDefinitions[viewMode].label)}
              </DropdownMenu.Item>
            );
          })}
        </DropdownMenu>
      )}
    </span>
  );
};
